module.exports = __webpack_public_path__ + "img/Icon_WriteAlimBtn.57f3c371.png";